import './UserFavoriteEvents.scss';

function UserFavoriteEvents() {
    return (
        <>
            Favorite Events
        </>
    )
}

export default UserFavoriteEvents
